import _ from "lodash";

export function getGlobalFeatureGroups(subscribed) {
  if (this.featureGroups && this.selectedPrincipal.id) {
    const principalId =
      typeof this.selectedPrincipal.id === "string"
        ? this.selectedPrincipal.id
        : "xx";
    const featureGroups = this.featureGroups.filter(
      feature =>
        !feature.owner &&
        (subscribed === null
          ? true
          : subscribed
          ? feature.principals.includes(principalId)
          : !feature.principals.includes(principalId))
    );
    if (!subscribed)
      featureGroups.forEach(featureGroup => {
        featureGroup.features = _.sortBy(featureGroup.features, feature =>
          feature.title.toLowerCase()
        );
      });
    return featureGroups;
  } else return [];
}
